export const countryList = [{ country_code: 'SG' }]